export class Notify {
    constructor(data: string | HTMLElement) {
        if (typeof data == "object") {
            data = data.outerHTML;
        }
        let notifyWrapper = document.querySelector('.notify-wrapper');
        let message = document.createElement('div');
        message.classList.add('message');
        message.innerHTML = data;
        notifyWrapper.append(message);

        setTimeout(() => {
            message.classList.add('visible');
        }, 100);

        setTimeout(() => {
            this.close(message);
        }, 5000);

        message.addEventListener('click', () => {
            this.close(message);
        });
    }

    close(message: HTMLDivElement) {
        if (!message.parentElement) return;
        message.classList.remove('visible');
        setTimeout(() => {
            if (!message.parentElement) return;
            message.parentElement.removeChild(message);
        }, 250);
    }
}